function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_awesome-child",
  "data-name": "Icon awesome-child",
  d: "M8.438,5.063A5.063,5.063,0,1,1,13.5,10.125,5.062,5.062,0,0,1,8.438,5.063Zm17.9.1a2.25,2.25,0,0,0-3.182,0L17.068,11.25H9.932L3.841,5.159A2.25,2.25,0,1,0,.659,8.341l6.653,6.653V33.75A2.25,2.25,0,0,0,9.563,36h1.125a2.25,2.25,0,0,0,2.25-2.25V25.875h1.125V33.75A2.25,2.25,0,0,0,16.313,36h1.125a2.25,2.25,0,0,0,2.25-2.25V14.994l6.653-6.653a2.25,2.25,0,0,0,0-3.182Z",
  transform: "translate(0)",
  fill: "#1aa0e0"
});

function SvgIconAge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 36,
    viewBox: "0 0 27 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAge);
export default __webpack_public_path__ + "static/media/icon-age.5c81a105.svg";
export { ForwardRef as ReactComponent };